import React, { useState } from 'react';

import PortfolioDetail from '../../components/portfolios/portfolio/PortfolioDetail';
import HeaderSubTitle from '../../components/controls/HeaderSubTitle';


const PagePortfolio: React.FC = () => {
  // const { id } = useParams<{ id: string }>(); // in case we want to fetch portfolio by id in the future

  return (
    <>  
      {/* <header className="app-header container">
        <h1>{portfolioNaam}</h1>
        <HeaderSubTitle text={portfolioOmschijving} />
      </header> */}

      <div className="content portfolio-detail">
        <PortfolioDetail />
      </div>
    </>
  );
};

export default PagePortfolio;
